import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import { BlockList } from "@circle-react-shared/BuilderUI/BlockList/BlockList";
import { ElementsList } from "../ElementsList";
import { Layers } from "../Layers";
import { SiteThemes } from "../SiteThemes";
import { Buttons } from "../ThemeConfiguration/SiteStyles/Tokens/Buttons";
import { ButtonStyles } from "../ThemeConfiguration/SiteStyles/Tokens/Buttons/ButtonStyles";
import { TextStyles } from "../ThemeConfiguration/SiteStyles/Tokens/Text/TextStyles";

export const ActionView = () => {
  const view = useBuilderStore(state => state.actionSidebarView);

  switch (view) {
    case "addElements":
      return <ElementsList />;
    case "addBlocks":
      return <BlockList />;
    case "siteThemeList":
      return <SiteThemes />;
    case "layers":
      return <Layers />;
    case "h1TextStyles":
    case "h2TextStyles":
    case "h3TextStyles":
    case "h4TextStyles":
    case "h5TextStyles":
    case "h6TextStyles":
    case "p1TextStyles":
    case "p2TextStyles":
    case "p3TextStyles":
      return <TextStyles />;
    case "primaryButton":
    case "secondaryButton":
      return <ButtonStyles />;
    case "buttonStyles":
      return <Buttons />;
    default:
      return null;
  }
};
